import React, { useState } from 'react';
import ConsultationModal from '../components/ConsultationModal';
import sherylImage from '../img/sw.png';
import sashaImage from '../img/sm.png';
import img8 from '../img/8.png';

function About() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="min-h-screen">
      <section className="page-hero">
        <div className="absolute inset-0 z-0">
          <img
            src={img8}
            alt="Sheryl Williams hair replacement studio work"
            className="h-full w-full object-cover object-top opacity-45"
          />
          <div className="page-hero-scrim" />
        </div>
        <div className="container relative z-10 mx-auto px-4">
          <p className="section-kicker text-primary-200">About</p>
          <h1 className="max-w-3xl font-display text-5xl font-semibold leading-tight md:text-6xl">
            Sheryl Williams
          </h1>
          <p className="mt-5 max-w-2xl text-xl leading-relaxed text-white/85">
            Over 20 years helping clients regain confidence through private, natural-looking hair replacement.
          </p>
        </div>
      </section>

      <section className="bg-white py-20">
        <div className="container mx-auto px-4">
          <div className="grid items-center gap-12 md:grid-cols-2">
            <div className="overflow-hidden">
              <img
                src={sherylImage}
                alt="Sheryl Williams"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div>
              <p className="section-kicker">Our story</p>
              <h2 className="section-heading">Built around one specialty</h2>
              <p className="mb-4 leading-relaxed text-ink-muted">
                Founded by Sheryl Williams in 2000, the studio has grown into a trusted destination for
                custom hair replacement across Pennsylvania and New Jersey.
              </p>
              <p className="mb-4 leading-relaxed text-ink-muted">
                Every visit is private. We take time to understand your coverage needs, lifestyle, and
                the finished look you want — then design a system and care plan around that.
              </p>
              <p className="leading-relaxed text-ink-muted">
                Clients come for information. They stay because the result looks natural, feels secure,
                and is supported with clear maintenance guidance.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-surface py-20">
        <div className="container mx-auto px-4">
          <div className="mb-12 text-center">
            <p className="section-kicker">Team</p>
            <h2 className="section-heading mb-0">The specialists behind your result</h2>
          </div>
          <div className="mx-auto grid max-w-4xl gap-12 md:grid-cols-2">
            <div>
              <div className="mb-5 aspect-square overflow-hidden">
                <img
                  src={sherylImage}
                  alt="Sheryl Williams"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <h3 className="font-display text-3xl font-semibold">Sheryl Williams</h3>
              <p className="mt-1 text-primary-700">Founder & Lead Specialist</p>
              <p className="mt-3 text-ink-muted">
                Guides consultations, system design, and the finishing details that make a replacement look like your hair.
              </p>
            </div>
            <div>
              <div className="mb-5 aspect-square overflow-hidden">
                <img
                  src={sashaImage}
                  alt="Sasha Martin"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <h3 className="font-display text-3xl font-semibold">Sasha Martin</h3>
              <p className="mt-1 text-primary-700">Senior Hair Specialist</p>
              <p className="mt-3 text-ink-muted">
                Supports fitting, blending, and ongoing maintenance so your system stays comfortable and natural.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white py-20">
        <div className="container mx-auto px-4">
          <div className="mb-12 max-w-3xl">
            <p className="section-kicker">How we work</p>
            <h2 className="section-heading">What every client can expect</h2>
          </div>
          <div className="grid gap-10 md:grid-cols-3">
            {[
              {
                title: 'Compassion',
                copy: 'Hair loss is personal. Appointments stay private, patient, and judgment-free.',
              },
              {
                title: 'Craft',
                copy: 'Color, density, fit, and blend are handled with the detail a natural result requires.',
              },
              {
                title: 'Clarity',
                copy: 'You leave knowing the next step — whether that is more information or a system plan.',
              },
            ].map((item) => (
              <div key={item.title} className="border-t border-primary-200 pt-6">
                <h3 className="font-display text-2xl font-semibold text-ink">{item.title}</h3>
                <p className="mt-3 leading-relaxed text-ink-muted">{item.copy}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-primary-700 py-16 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="font-display text-4xl font-semibold">Ready to talk through your options?</h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-primary-50">
            Book a free consultation and meet the team in a private setting.
          </p>
          <button
            type="button"
            onClick={() => setIsModalOpen(true)}
            className="mt-8 rounded-full bg-white px-8 py-3 font-semibold text-primary-700 transition duration-300 hover:bg-primary-50"
          >
            Book Free Consultation
          </button>
        </div>
      </section>

      <ConsultationModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
}

export default About;
